import * as React from "react"

const Rewatch = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M3.9 4.4v-.5h1v1.38c.2-.24.45-.44.74-.64a4.1 4.1 0 1 1-1.08 5.6l-.27-.41.83-.55.28.42a3.1 3.1 0 1 0 .81-4.24c-.31.22-.5.4-.65.59-.08.1-.14.2-.2.34l1.57-.2.5-.06.12 1-.5.06-2.6.32-.56.07V4.4Z" />
  </svg>
)

export default Rewatch
